import React from 'react';
import PropTypes from 'prop-types';
import Picture from '@deporvillage/picture-component';
import { Config } from '@deporvillage/utils-library-component';

import styles from './HubtypeWebchat.module.scss';

const HubtypeWebchat = ({ elementId, botonicUrl, appId, userId, email, onClick }) => {
    const elem = React.useRef(null);
    const { country, lang } = React.useContext(Config);

    const isActive = !!(appId && botonicUrl && elementId);

    /* istanbul ignore next */
    const webchatConfig = {
        hostId: elementId,
        appId: appId,
        onInit: async (app) => {
            // eslint-disable-next-line no-undef
            await window.botonicOnInit(app);
            app.updateUser({
                extra_data: {
                    country: country.code,
                    language: lang,
                    userId: userId || null,
                    email: email || null,
                },
            });
            app.open();
        },
        onOpen: async (app) => {
            // eslint-disable-next-line no-undef
            await window.botonicOnOpen(app);
            await onClick && onClick();
        },
        onClose: async (app) => {
            // eslint-disable-next-line no-undef
            await window.botonicOnClose(app);
        },
        onMessage: async (app, message) => {
            // eslint-disable-next-line no-undef
            await window.botonicOnMessage(app, message);
        },
    };

    const loadBotonic = (elementId, botonicUrl, webchatConfig) => {
        if (!isActive) return;
        /* eslint-disable no-undef */
        let script = document.createElement('script');
        script.src = botonicUrl;
        script.async = true;
        script.setAttribute('fetchpriority', 'low');
        script.onload = () => executeBotonic(elementId, webchatConfig);
        elem.current.appendChild(script);
        /* eslint-enable no-undef */
    };

    const executeBotonic = (elementId, webchatConfig) =>
        // eslint-disable-next-line no-undef
        Botonic.render(document.getElementById(elementId), webchatConfig);

    return (
        <div
            id={elementId}
            className={styles['hubtype-webchat-component']}
            ref={elem}
        >
            <div className={styles['wrapper']} onClick={() => loadBotonic(elementId, botonicUrl, webchatConfig)}>

                <div className={styles['image-bubble']}>
                    <Picture
                        src={`/static/hubtype/hubtype-gray-image-bubble.png`}
                        name={'Hubtype'}
                        width={55}
                        height={55}
                        lazy
                        transparent
                        quality={100}
                    />
                </div>
            </div>
        </div>
    );
};

HubtypeWebchat.propTypes = {
    elementId: PropTypes.string,
    botonicUrl: PropTypes.string,
    appId: PropTypes.string,
    userId: PropTypes.number,
    email: PropTypes.string,
    onClick: PropTypes.func
};

export default HubtypeWebchat;
